import { Chip } from "@mui/material";
import type { DerivedAccount } from "../api/types";
import { derivedAccountLabel } from "../logic/derivedAccount";

export type DerivedAccountChipProps = {
  /** The server's (or, on the details page, the client's) derived account. */
  value: DerivedAccount | null;
  size?: "small" | "medium";
};

/**
 * The account label as a chip. Not an `EntityChip`: there is no registry
 * entity behind a derived account, so there is no logo or colour to look up.
 * An unclassified row is shown muted, so it reads as "nothing", not as a
 * label in its own right.
 */
export const DerivedAccountChip = ({
  value,
  size = "medium",
}: DerivedAccountChipProps) => (
  <Chip
    label={derivedAccountLabel(value)}
    size={size}
    variant={value ? "filled" : "outlined"}
    sx={value ? undefined : { color: "text.secondary" }}
  />
);
